import { ComputedRef, InjectionKey, Ref } from 'vue'
import { Dialog } from '@/dialog'
import { FileToSign } from './types'

const dialogKey: InjectionKey<Dialog> = Symbol('dialog')
const AuthorizationKey: InjectionKey<ComputedRef<string | null>> =
  Symbol('Authorization')
const fileToSignKey: InjectionKey<Ref<FileToSign[]>> = Symbol('fileToSign')

export { AuthorizationKey, dialogKey, fileToSignKey }
